import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FarmService } from '.';
import { environment } from '../../../environments/environment';
import { SM } from '../../../assets/data/enum/storeModel.enum';
import { CONNECTION_HUB_CONNECTION_STATUSES } from '../_models/connection-hub/connection-hub';
import { ConnectionHubService } from './connection-hub/connection-hub.service';

@Injectable()
export class AllynavService {
  constructor(private connectionHubService: ConnectionHubService) {}

  // get a Allynav status
  // TODO: move to abstract class / interfaces?
  getAllynavStatus(): Observable<boolean> {
    return this.connectionHubService.getProvidersStatus().pipe(
      map((providers) => {
        // Stop if no providers are found
        if (!providers || providers.length === 0) {
          return false;
        }
        // Getting the generic provider
        const allynavProvider = providers.find((provider) =>
          provider.storeModel.includes(SM.SM_EQUIPMENT_TELEMETRY_ALLYNAV)
        );

        // Return the status of the provider
        return (
          allynavProvider && allynavProvider.status === CONNECTION_HUB_CONNECTION_STATUSES.CONNECTED
        );
      })
    );
  }
}
